import { type UUID } from '~/types/common';

/**
 * Query key factory for user-related queries.
 */
export const queryKeysUser = {
  base: () => 'user' as const,
  getAdmin: (userId: UUID) =>
    [queryKeysUser.base(), 'detail', 'admin', userId] as const,
  getAllAdmin: (queryParams: Record<string, unknown> = {}) =>
    [queryKeysUser.base(), 'list', 'admin', queryParams] as const,
  getAllInAccount: (queryParams: Record<string, unknown> = {}) =>
    [queryKeysUser.base(), 'list', 'inAccount', queryParams] as const,
  getBulkAdmin: (ids: UUID[], includeCompanyInformation: boolean) =>
    [
      queryKeysUser.base(),
      'bulkAdmin',
      { ids, includeCompanyInformation },
    ] as const,
  getIdentityProviderLinksAdmin: (userId: UUID) =>
    [
      queryKeysUser.base(),
      'identityProviderLinks',
      'admin',
      { userId },
    ] as const,
  getMe: () => [queryKeysUser.base(), 'me'] as const,
  getSettingsAdmin: (userId: UUID | undefined) =>
    [queryKeysUser.base(), 'settings', 'admin', { userId }] as const,
} as const;
